export const userRolesOptions = [
  { value: 'Manager', label: 'Manager' },
  {
    value: 'SystemAdministrators',
    label: 'System Administrator'
  },
  { value: 'Operator', label: 'Operator' },
  { value: 'Customer', label: 'Customer' }
];

export const userEnabledOptions = [
  { value: true, label: 'Active' },
  { value: false, label: 'Inactive' }
];

export const userFormData = {
  username: '',
  name: '',
  email: '',
  company: '',
  companyId: '',
  phone: '',
  groups: 'Operator',
  enabled: true,
  password: ''
};
